export const ThreeFourKLessons = [
  {
    lessonNumber: 1,
    lessonTitle: "Exploring a traditional Korean village",

    PreKoreanWord1:
      "When I arrived at the traditional village, the guide did a",
    KoreanWord1: "절",
    KoreanWord1EngTranslation: "bow",
    PostKoreanWord1: "to greet me.",

    PreKoreanWord2: "At the entrance, workers were doing small",
    KoreanWord2: "정비",
    KoreanWord2EngTranslation: "maintenance",
    PostKoreanWord2: "on the old wooden gate.",

    PreKoreanWord3: "A sign warned visitors to pay close",
    KoreanWord3: "주의",
    KoreanWord3EngTranslation: "attention; caution",
    PostKoreanWord3: "while walking on the stone paths.",

    PreKoreanWord4: "I hadn’t visited this place since",
    KoreanWord4: "지난번",
    KoreanWord4EngTranslation: "last time",
    PostKoreanWord4: "school trip years ago.",

    PreKoreanWord5: "I decided to",
    KoreanWord5: "집어넣다",
    KoreanWord5EngTranslation: "to put in",
    PostKoreanWord5: "my belongings in a locker before entering the museum.",

    PreKoreanWord6: "I saw population",
    KoreanWord6: "통계",
    KoreanWord6EngTranslation: "statistics",
    PostKoreanWord6: "showing how the village had changed.",

    PreKoreanWord7: "They also had a digital",
    KoreanWord7: "파일",
    KoreanWord7EngTranslation: "file",
    PostKoreanWord7: "you could download with more details.",

    PreKoreanWord8: "A large information",
    KoreanWord8: "판",
    KoreanWord8EngTranslation: "board; panel",
    PostKoreanWord8: "showed all the important landmarks.",

    PreKoreanWord9: "There is a story about a local",
    KoreanWord9: "피해자",
    KoreanWord9EngTranslation: "victim",
    PostKoreanWord9: "from an old folktale.",

    PreKoreanWord10: "Understanding the past is",
    KoreanWord10: "필수적",
    KoreanWord10EngTranslation: "essential",
    PostKoreanWord10: "to appreciating history.",

    PreKoreanWord11: "A school exhibit showed old",
    KoreanWord11: "학용품",
    KoreanWord11EngTranslation: "school supplies",
    PostKoreanWord11: "used by students long ago.",

    PreKoreanWord12: "Outside, there were beautifully painted",
    KoreanWord12: "화분",
    KoreanWord12EngTranslation: "flower pots",
    PostKoreanWord12: "full of flowers.",

    PreKoreanWord13: "The sun was very",
    KoreanWord13: "환하다",
    KoreanWord13EngTranslation: "bright",
    PostKoreanWord13: "that day, making everything feel warm.",

    PreKoreanWord14: "I stopped to admire the",
    KoreanWord14: "갈색",
    KoreanWord14EngTranslation: "brown",
    PostKoreanWord14: "bark of the trees.",

    PreKoreanWord15: "Unfortunately, I had a light",
    KoreanWord15: "감기",
    KoreanWord15EngTranslation: "cold (illness)",
    PostKoreanWord15: "so I walked slowly.",

    PreKoreanWord16: "A map of",
    KoreanWord16: "강남",
    KoreanWord16EngTranslation: "Gangnam",
    PostKoreanWord16: "compared old homes to the ones in this village.",

    PreKoreanWord17: "One display showed how thieves could be",
    KoreanWord17: "구속되다",
    KoreanWord17EngTranslation: "to be arrested",
    PostKoreanWord17: "by local guards.",

    PreKoreanWord18: "I began to",
    KoreanWord18: "돌아다니다",
    KoreanWord18EngTranslation: "to wander; walk around",
    PostKoreanWord18: "through the narrow alleys.",

    PreKoreanWord19: "Signs listed foods, crafts, stories,",
    KoreanWord19: "등등",
    KoreanWord19EngTranslation: "etc.; and so on",
    PostKoreanWord19: "sold by local merchants.",

    PreKoreanWord20: "The traditional houses looked absolutely",
    KoreanWord20: "멋지다",
    KoreanWord20EngTranslation: "wonderful; splendid",
    PostKoreanWord20: "in the afternoon light.",

    PreKoreanWord21: "However, development had caused some",
    KoreanWord21: "반발",
    KoreanWord21EngTranslation: "opposition; backlash",
    PostKoreanWord21: "from those who want to preserve the village.",

    PreKoreanWord22: "I stopped for lunch and enjoyed rice with several tasty",
    KoreanWord22: "반찬",
    KoreanWord22EngTranslation: "side dishes",
    PostKoreanWord22: "on the side.",

    PreKoreanWord23: "A sign explained that checks were in place for fire",
    KoreanWord23: "방지",
    KoreanWord23EngTranslation: "prevention",
    PostKoreanWord23: "because the buildings were very old.",

    PreKoreanWord24: "I noticed the smell of food had",
    KoreanWord24: "배다",
    KoreanWord24EngTranslation: "to soak in; permeate",
    PostKoreanWord24: "into my jacket after walking near the food stalls.",

    PreKoreanWord25: "The tour promised a full refund, offering a",
    KoreanWord25: "보장",
    KoreanWord25EngTranslation: "guarantee",
    PostKoreanWord25: "if guests were not satisfied.",

    PreKoreanWord26: "I felt the need to",
    KoreanWord26: "빠져나오다",
    KoreanWord26EngTranslation: "to get out; escape",
    PostKoreanWord26: "the crowded area.",

    PreKoreanWord27: "At one house, water began to",
    KoreanWord27: "새다",
    KoreanWord27EngTranslation: "to leak",
    PostKoreanWord27: "from the roof after rain.",

    PreKoreanWord28: "I listened as the guide",
    KoreanWord28: "소개되다",
    KoreanWord28EngTranslation: "to be introduced",
    PostKoreanWord28: "the history of an old ceremonial hall.",

    PreKoreanWord29: "A farmer showed me a rare plant",
    KoreanWord29: "씨",
    KoreanWord29EngTranslation: "seed",
    PostKoreanWord29: "he had been growing.",

    PreKoreanWord30: "Inside the main hall, the",
    KoreanWord30: "안쪽",
    KoreanWord30EngTranslation: "inner part",
    PostKoreanWord30: "room displayed old artifacts.",

    PreKoreanWord31: "One performer complained he",
    KoreanWord31: "억울하다",
    KoreanWord31EngTranslation: "to feel wronged; unfair",
    PostKoreanWord31: "and that people ignored him.",

    PreKoreanWord32: "People continued to",
    KoreanWord32: "오가다",
    KoreanWord32EngTranslation: "to come and go",
    PostKoreanWord32: "between food stalls and souvenir shops.",

    PreKoreanWord33: "To watch traditional dancing, early arrival was",
    KoreanWord33: "요구되다",
    KoreanWord33EngTranslation: "to be required",
    PostKoreanWord33: "due to the limited seating.",

    PreKoreanWord34: "A speaker played a recorded",
    KoreanWord34: "음성",
    KoreanWord34EngTranslation: "audio; voice",
    PostKoreanWord34: "explaining old rituals.",

    PreKoreanWord35: "After wandering for a long time, I",
    KoreanWord35: "이윽고",
    KoreanWord35EngTranslation: "finally; at last",
    PostKoreanWord35: "reached the center square.",

    PreKoreanWord36: "The festival area was filled with colorful",
    KoreanWord36: "장식",
    KoreanWord36EngTranslation: "decorations",
    PostKoreanWord36: "hanging from the roofs.",

    PreKoreanWord37: "It's amazing how the story",
    KoreanWord37: "전개하다",
    KoreanWord37EngTranslation: "to unfold; develop",
    PostKoreanWord37: "over time.",

    PreKoreanWord38: "Most ceremonies happened the",
    KoreanWord38: "전날",
    KoreanWord38EngTranslation: "the day before",
    PostKoreanWord38: "major harvest festivals.",

    PreKoreanWord39: "We also got a",
    KoreanWord39: "전반적",
    KoreanWord39EngTranslation: "overall; general",
    PostKoreanWord39: "explanation of the village’s culture.",

    PreKoreanWord40: "I tried to",
    KoreanWord40: "척하다",
    KoreanWord40EngTranslation: "to pretend",
    PostKoreanWord40: "I wasn’t tired.",

    PreKoreanWord41: "Some shops showed traditional",
    KoreanWord41: "풍습",
    KoreanWord41EngTranslation: "customs",
    PostKoreanWord41: "through displays of old clothing.",

    PreKoreanWord42: "In the",
    KoreanWord42: "한가운데",
    KoreanWord42EngTranslation: "middle",
    PostKoreanWord42: "of the village stood a 300-year-old tree.",

    PreKoreanWord43: "Access to the tower was",
    KoreanWord43: "한정되다",
    KoreanWord43EngTranslation: "to be limited",
    PostKoreanWord43: "to only 20 people per hour.",

    PreKoreanWord44: "Despite the challenge, I was determined to",
    KoreanWord44: "해내다",
    KoreanWord44EngTranslation: "to accomplish; pull off",
    PostKoreanWord44: "the steep climb.",

    PreKoreanWord45: "A little boy started making a funny",
    KoreanWord45: "흉내",
    KoreanWord45EngTranslation: "imitation",
    PostKoreanWord45: "of the village storyteller, everyone laughed.",

    PreKoreanWord46: "One exhibit showed a",
    KoreanWord46: "감옥",
    KoreanWord46EngTranslation: "prison",
    PostKoreanWord46: "used centuries ago.",

    PreKoreanWord47: "You'd end up there if you didn't",
    KoreanWord47: "갚다",
    KoreanWord47EngTranslation: "to repay",
    PostKoreanWord47: "your debts.",

    PreKoreanWord48: "Another guide spoke about preserving a",
    KoreanWord48: "건전하다",
    KoreanWord48EngTranslation: "wholesome; sound",
    PostKoreanWord48: "balance between modern life and tradition.",

    PreKoreanWord49: "Near the exit, a beautiful outdoor",
    KoreanWord49: "결혼식",
    KoreanWord49EngTranslation: "wedding",
    PostKoreanWord49: "area was being set up.",

    PreKoreanWord50: "You'd need a",
    KoreanWord50: "계산기",
    KoreanWord50EngTranslation: "calculator",
    PostKoreanWord50: "to work out the cost of this place.",
  },
  {
    lessonNumber: 2,
    lessonTitle: "A Day at a Korean High School",

    PreKoreanWord1: "Before class, many students gathered in the",
    KoreanWord1: "광장",
    KoreanWord1EngTranslation: "plaza; square",
    PostKoreanWord1: "to talk.",

    PreKoreanWord2: "Did I finish my homework?",
    KoreanWord2: "그렇지",
    KoreanWord2EngTranslation: "of course; that's right",
    PostKoreanWord2: ", of course I did.",

    PreKoreanWord3: "Suddenly, a loud noise made a window",
    KoreanWord3: "깨다",
    KoreanWord3EngTranslation: "to break",
    PostKoreanWord3: ".",

    PreKoreanWord4: "The teacher closed the door",
    KoreanWord4: "꽉",
    KoreanWord4EngTranslation: "tightly; firmly",
    PostKoreanWord4: "to block the noise.",

    PreKoreanWord5: "A student tried to",
    KoreanWord5: "끼우다",
    KoreanWord5EngTranslation: "to insert; put into",
    PostKoreanWord5: "a piece of paper into his bag.",

    PreKoreanWord6: "Someone began to",
    KoreanWord6: "노래하다",
    KoreanWord6EngTranslation: "to sing",
    PostKoreanWord6: "loudly.",

    PreKoreanWord7: "Another student used scissors to",
    KoreanWord7: "다듬다",
    KoreanWord7EngTranslation: "to trim; tidy up",
    PostKoreanWord7: "the edge of a poster.",

    PreKoreanWord8: "Our math test was so easy it was",
    KoreanWord8: "다름없다",
    KoreanWord8EngTranslation: "no different (from)",
    PostKoreanWord8: "from last week’s review sheet.",

    PreKoreanWord9: "The student president walked in looking",
    KoreanWord9: "당당하다",
    KoreanWord9EngTranslation: "confident; dignified",
    PostKoreanWord9: "and proud.",

    PreKoreanWord10: "In science class, we talked about a large",
    KoreanWord10: "댐",
    KoreanWord10EngTranslation: "dam",
    PostKoreanWord10: "near our city.",

    PreKoreanWord11: "The teacher brought a big",
    KoreanWord11: "덩어리",
    KoreanWord11EngTranslation: "chunk; lump",
    PostKoreanWord11: "of clay for an experiment.",

    PreKoreanWord12: "Our teacher said we must use our",
    KoreanWord12: "두뇌",
    KoreanWord12EngTranslation: "brain",
    PostKoreanWord12: "wisely.",

    PreKoreanWord13: "She wrote formulas, words",
    KoreanWord13: "등",
    KoreanWord13EngTranslation: "etc.",
    PostKoreanWord13: "on the board.",

    PreKoreanWord14: "It was hard to focus because it was",
    KoreanWord14: "모처럼",
    KoreanWord14EngTranslation: "for the first time in a while",
    PostKoreanWord14: "warm and sunny outside.",

    PreKoreanWord15: "We studied basic",
    KoreanWord15: "물리학",
    KoreanWord15EngTranslation: "physics",
    PostKoreanWord15: "principles and ideas.",

    PreKoreanWord16: "One boy arrived late and had to accept a",
    KoreanWord16: "벌",
    KoreanWord16EngTranslation: "punishment",
    PostKoreanWord16: "from the teacher.",

    PreKoreanWord17: "Some students had a very",
    KoreanWord17: "부정적",
    KoreanWord17EngTranslation: "negative",
    PostKoreanWord17: "attitude about studying.",

    PreKoreanWord18: "Others talked about visiting the",
    KoreanWord18: "북부",
    KoreanWord18EngTranslation: "northern region",
    PostKoreanWord18: "part of Korea during vacation.",

    PreKoreanWord19: "In chemistry, we worked on the",
    KoreanWord19: "분리",
    KoreanWord19EngTranslation: "separation",
    PostKoreanWord19: "of different liquids.",

    PreKoreanWord20: "The experiment took a",
    KoreanWord20: "상당",
    KoreanWord20EngTranslation: "considerable",
    PostKoreanWord20: "amount of time.",

    PreKoreanWord21: "Some chemicals were very",
    KoreanWord21: "세다",
    KoreanWord21EngTranslation: "strong; intense",
    PostKoreanWord21: "and smelled a lot.",

    PreKoreanWord22: "After class, my friend asked me to",
    KoreanWord22: "소개",
    KoreanWord22EngTranslation: "to introduce",
    PostKoreanWord22: "her to a boy.",

    PreKoreanWord23: "She wants to talk on the",
    KoreanWord23: "수화기",
    KoreanWord23EngTranslation: "telephone receiver",
    PostKoreanWord23: "with him.",

    PreKoreanWord24: "They might become",
    KoreanWord24: "애인",
    KoreanWord24EngTranslation: "lovers; boyfriend/girlfriend",
    PostKoreanWord24: "if things go well.",

    PreKoreanWord25: "She said that",
    KoreanWord25: "애초",
    KoreanWord25EngTranslation: "at first; originally",
    PostKoreanWord25: "she planned to study alone.",

    PreKoreanWord26: "Her notebook paper was very",
    KoreanWord26: "얇다",
    KoreanWord26EngTranslation: "thin",
    PostKoreanWord26: "and kept tearing.",

    PreKoreanWord27: "At lunch we added",
    KoreanWord27: "양념",
    KoreanWord27EngTranslation: "seasoning",
    PostKoreanWord27: "to our food.",

    PreKoreanWord28: "We sat together",
    KoreanWord28: "에",
    KoreanWord28EngTranslation: "at",
    PostKoreanWord28: "the cafeteria.",

    PreKoreanWord29: "Someone joked that the air outside was",
    KoreanWord29: "오염되다",
    KoreanWord29EngTranslation: "to be polluted",
    PostKoreanWord29: "so we should be careful.",

    PreKoreanWord30: "This caused a big",
    KoreanWord30: "오해",
    KoreanWord30EngTranslation: "misunderstanding",
    PostKoreanWord30: "because the new student didn’t understand the joke.",

    PreKoreanWord31: "She asked,",
    KoreanWord31: "웬일",
    KoreanWord31EngTranslation: "what’s the matter?",
    PostKoreanWord31: "? Is the air really bad?",

    PreKoreanWord32: "In ethics class, we discussed human",
    KoreanWord32: "의식",
    KoreanWord32EngTranslation: "consciousness",
    PostKoreanWord32: "and awareness.",

    PreKoreanWord33: "The teacher told us to",
    KoreanWord33: "의지하다",
    KoreanWord33EngTranslation: "to rely on",
    PostKoreanWord33: "our friends when life gets stressful.",

    PreKoreanWord34: "During break time I wrote in my school",
    KoreanWord34: "일기",
    KoreanWord34EngTranslation: "diary",
    PostKoreanWord34: ".",

    PreKoreanWord35: "I promised myself I would",
    KoreanWord35: "절대",
    KoreanWord35EngTranslation: "never",
    PostKoreanWord35: "give up on studying.",

    PreKoreanWord36: "So I'll",
    KoreanWord36: "제한하다",
    KoreanWord36EngTranslation: "to limit",
    PostKoreanWord36: "how much time I spend on games.",

    PreKoreanWord37: "The teacher reminded us to",
    KoreanWord37: "존중하다",
    KoreanWord37EngTranslation: "to respect",
    PostKoreanWord37: "each other.",

    PreKoreanWord38: "Our art class took place in an old",
    KoreanWord38: "창고",
    KoreanWord38EngTranslation: "warehouse",
    PostKoreanWord38: "behind the gym.",

    PreKoreanWord39: "The room was cold",
    KoreanWord39: "채",
    KoreanWord39EngTranslation: "even though; despite",
    PostKoreanWord39: "with heaters on.",

    PreKoreanWord40: "The art teacher told us to",
    KoreanWord40: "책임지다",
    KoreanWord40EngTranslation: "to take responsibility",
    PostKoreanWord40: "for cleaning our brushes.",

    PreKoreanWord41: "She said art was a symbol of",
    KoreanWord41: "청춘",
    KoreanWord41EngTranslation: "youth",
    PostKoreanWord41: "and freedom.",

    PreKoreanWord42: "We were only in the",
    KoreanWord42: "초반",
    KoreanWord42EngTranslation: "early stage",
    PostKoreanWord42: "of the semester, but we were busy.",

    PreKoreanWord43: "Outside, a large",
    KoreanWord43: "트럭",
    KoreanWord43EngTranslation: "truck",
    PostKoreanWord43: "was delivering supplies to the school.",

    PreKoreanWord44: "A student bought noodles with",
    KoreanWord44: "파",
    KoreanWord44EngTranslation: "spring onion",
    PostKoreanWord44: "on top.",

    PreKoreanWord45: "Our teacher said we need a",
    KoreanWord45: "폭넓다",
    KoreanWord45EngTranslation: "broad; wide-ranging",
    PostKoreanWord45: "understanding.",

    PreKoreanWord46: "She said emotions are often",
    KoreanWord46: "표현되다",
    KoreanWord46EngTranslation: "to be expressed",
    PostKoreanWord46: "through writing.",

    PreKoreanWord47: "A freshman with his",
    KoreanWord47: "학번",
    KoreanWord47EngTranslation: "student ID number",
    PostKoreanWord47: "on his badge introduced himself.",

    PreKoreanWord48: "After school I went to my",
    KoreanWord48: "학원",
    KoreanWord48EngTranslation: "academy; cram school",
    PostKoreanWord48: "to study English vocabulary.",

    PreKoreanWord49: "My tutor needed",
    KoreanWord49: "허가",
    KoreanWord49EngTranslation: "permission",
    PostKoreanWord49: "to use a bigger classroom.",

    PreKoreanWord50: "On my way home I got lost and began to",
    KoreanWord50: "헤매다",
    KoreanWord50EngTranslation: "to wander around; be lost",
    PostKoreanWord50: "around the neighbourhood.",
  },
];
